// document.addEventListener('DOMContentLoaded', function() {

//     new Swiper('.taleSwiper', {
//         slidesPerView: 1,
//         spaceBetween: 20,
//         pagination: { el: '.tale-pagination', clickable: true }
//     });

//     const swiper = new Swiper('.collection-swiper', {
//         effect: 'fade',
//         fadeEffect: { crossFade: true },
//         speed: 500,
//         autoHeight: true,
//         on: {
//             slideChange: function() {
//                 document.querySelectorAll('.collection-item').forEach((btn, i) => {
//                     btn.classList.toggle('active', i === this.activeIndex);
//                 });
//             }
//         }
//     });

//     const scrollTo = el => {
//         if (!el) return;
//         el.scrollIntoView({ behavior: 'smooth', block: 'start' });
//     };

//     window.goToSlide = function(index) {
//         swiper.slideTo(index);
//         scrollTo(document.getElementById('collection-detail'));
//     };

//     // Tab buttons
//     document.querySelectorAll('.collection-item').forEach(btn => {
//         btn.addEventListener('click', () => goToSlide(parseInt(btn.dataset.slide)));
//     });

//     // Only intercept hash-only links (same page navigation)
//     document.querySelectorAll('a[href^="#"]').forEach(link => {
//         link.addEventListener('click', function(e) {
//             e.preventDefault();
//             const hash = this.getAttribute('href').slice(1);
//             if (hash === 'signature-tale-section') {
//                 scrollTo(document.getElementById(hash));
//             } else if (hash.startsWith('collection-')) {
//                 goToSlide(parseInt(hash.split('-')[1]));
//             }
//         });
//     });

//     // Handle hash on page load
//     const hash = window.location.hash.slice(1);
//     if (hash === 'signature-tale-section') {
//         setTimeout(() => scrollTo(document.getElementById(hash)), 300);
//     } else if (hash.startsWith('collection-')) {
//         setTimeout(() => goToSlide(parseInt(hash.split('-')[1])), 300);
//     }

// });






    new Swiper('.taleSwiper', {
        slidesPerView: 1,
        spaceBetween: 20,
        pagination: { el: '.tale-pagination', clickable: true }
    });

    const swiper = new Swiper('.collection-swiper', {
        effect: 'fade',
        fadeEffect: { crossFade: true },
        speed: 500,
        autoHeight: true,
        on: {
            slideChange: function() {
                document.querySelectorAll('.collection-item').forEach((btn, i) => {
                    btn.classList.toggle('active', i === this.activeIndex);
                });
            }
        }
    });

    document.addEventListener('DOMContentLoaded', () => {
    const initialHash = window.location.hash.slice(1);

    // Prevent the browser's instant native jump-to-anchor
    if (initialHash) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
    }

    const scrollTo = el => {
        if (!el) return;
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    window.goToSlide = function(index) {
        swiper.slideTo(index);
        scrollTo(document.getElementById('collection-detail'));
    };

    // Tab buttons
    document.querySelectorAll('.collection-item').forEach(btn => {
        btn.addEventListener('click', () => goToSlide(parseInt(btn.dataset.slide)));
    });

    // Handle ALL hash links, same-page or cross-page
    document.querySelectorAll('a[href*="#"]').forEach(link => {
        link.addEventListener('click', function(e) {
            const url = new URL(this.href, window.location.href);
            const hash = url.hash.slice(1);
            if (!hash) return;

            const isSamePage = url.pathname === window.location.pathname;

            if (isSamePage) {
                // Already on the right page — just scroll/slide
                e.preventDefault();
                if (hash === 'signature-tale-section') {
                    scrollTo(document.getElementById(hash));
                } else if (hash.startsWith('collection-')) {
                    goToSlide(parseInt(hash.split('-')[1]));
                }
            }
            // else: let the browser navigate to the new page normally.
            // That page's own script will handle the hash on load (below).
        });
    });

    // Runs after landing on a page (fresh load OR navigated from another page)
    if (initialHash) {
        const runScroll = () => {
            if (initialHash === 'signature-tale-section') {
                scrollTo(document.getElementById(initialHash));
            } else if (initialHash.startsWith('collection-')) {
                goToSlide(parseInt(initialHash.split('-')[1]));
            }
        };
        // Wait a frame + short delay so layout/swiper are ready before scrolling
        window.requestAnimationFrame(() => setTimeout(runScroll, 300));
    }
});
